<!--
 @component

 The page where you use this component must have separate code that emits
 `rafResize` and `rafScroll` events; these events are not automatically
 configured by the component.

 If you are using the component on a www.propublica.org V5 page, they are
 already being emitted. Otherwise, see TKTK-doc-link.
-->

<script>
    /** @type { string[] } */
    export let steps;

    /** @type {HTMLElement} */
    let componentElement;

    /** @type {HTMLElement} */
    let componentElementItems;

    let scrollProgress = 0;
    let scrollTranslateAmount = 0;

    // TODO: not sure how to handle rafEvents dependency (because it's listening for rafScroll and rafReszie), come back to this later

    const clampNumber = (
        /** @type {number} */ min,
        /** @type {number} */ num,
        /** @type {number} */ max,
    ) => Math.max(Math.min(num, Math.max(min, max)), Math.min(min, max));

    function updateScroll() {
        const hScrollerBounds = componentElement.getBoundingClientRect();

        // Returns a number between 0 and 1, representing progress.
        const hScrollRatio = clampNumber(
            0,
            -1 *
                (hScrollerBounds.top /
                    (hScrollerBounds.height -
                        document.documentElement.clientHeight)),
            1,
        );

        const hScrollTotalAmount = componentElementItems?.scrollWidth ?? 0;

        // console.log(hScrollerBounds.top);
        // console.log(hScrollerBounds.height);
        // console.log(hScrollRatio);

        // Update scrollProgress and scrollTranslation, which are bound to the scroller wrapper div.
        // (Svelte will update the necessary style attributes automatically below.)
        scrollProgress = parseFloat(hScrollRatio.toFixed(2));
        if (
            hScrollerBounds.top <= 0 &&
            hScrollerBounds.bottom > document.documentElement.clientHeight
        ) {
            scrollTranslateAmount = Math.round(
                hScrollRatio *
                    (hScrollTotalAmount -
                        document.documentElement.clientWidth) *
                    -1,
            );
        }

        // Apply parallax transforms
        // TODO: either move this out to separate function or add a more generic query selector here
        componentElement
            .querySelectorAll(".custom-opener__spread-art")
            .forEach(function (e) {
                const parallax = e.dataset.parallax;
                // console.log(parallax);
                e.setAttribute(
                    "style",
                    `translate: ${scrollProgress * parallax}% 0 0`,
                );
            });
    }
</script>

<svelte:window on:rafScroll={updateScroll} on:rafResize={updateScroll} />

<div
    bind:this={componentElement}
    style:height="{componentElementItems
        ? componentElementItems.scrollWidth
        : 0}px"
    style:--scroll-width="{componentElementItems
        ? componentElementItems.scrollWidth
        : 0}px"
>
    <div class="hs-scroller__wrapper">
        <div
            bind:this={componentElementItems}
            class="hs-scroller__items"
            style:transform="translateX({scrollTranslateAmount}px)"
            style:--scroll-progress={scrollProgress}
        >
            {#each steps as step}
                <div class="hs-scroller__item">
                    {@html step}
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .hs-scroller__wrapper {
        align-items: left;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        height: 100vh;
        justify-content: center;
        position: sticky;
        overflow: hidden;
        top: 0;
        width: 100vw;
    }

    .hs-scroller__items {
        align-items: center;
        display: flex;
        gap: 0;
        transition: transform 0.01s; /* Custom thing, probably move out of component */
    }
</style>
